function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#50DB98"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.24841 12.136H8.89451C8.90544 12.3985 9.01117 12.6191 9.21169 12.7978C9.41586 12.9764 9.69477 13.0657 10.0484 13.0657C10.3838 13.0657 10.6554 12.9928 10.8633 12.847C11.0711 12.6975 11.1768 12.4988 11.1804 12.2509C11.1877 12.0576 11.1258 11.8899 10.9945 11.7478C10.8633 11.6056 10.6153 11.4816 10.2508 11.3759L9.32107 11.1188C7.99034 10.7069 7.32498 9.96676 7.32498 8.89854C7.32498 8.27874 7.5419 7.76103 7.97576 7.34541C8.40961 6.92979 8.96195 6.68734 9.63279 6.61807V5.42041H10.4531V6.629C11.0911 6.7165 11.607 6.96624 12.0008 7.37822C12.3945 7.7902 12.5914 8.31702 12.5914 8.95869H10.9562C10.9562 8.69619 10.8687 8.48473 10.6937 8.32432C10.5224 8.1639 10.2781 8.08369 9.96091 8.08369C9.67289 8.08369 9.43409 8.15661 9.24451 8.30244C9.05492 8.44463 8.96013 8.62874 8.96013 8.85478C8.96013 9.22301 9.23722 9.48551 9.79138 9.64228L10.7101 9.93213C12.1539 10.3478 12.8594 11.1243 12.8265 12.2618C12.8229 12.5972 12.7536 12.9017 12.6187 13.1751C12.4875 13.4485 12.3088 13.6764 12.0828 13.8587C11.8604 14.0373 11.6107 14.1813 11.3336 14.2907C11.0601 14.3965 10.7666 14.4657 10.4531 14.4985V15.7892H9.63279V14.4985C8.90727 14.4256 8.32758 14.1741 7.89373 13.7438C7.46352 13.31 7.24841 12.7741 7.24841 12.136Z",
  fill: "white"
});

var SvgUsdRound = function SvgUsdRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsdRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usdRound.ba221a79.svg";
export { ForwardRef as ReactComponent };